import type { MaybeRef } from "vue";

export function useTaskTypeOptions(_filter?: MaybeRef<string>) {
  const { data, taskFallbackIcon, taskItems, taskListDb, getTaskIcon, isLoading } =
    useTaskConfigDataCore();
  const filter = ref(_filter ?? "");

  const taskListSearchResults = computed(() => {
    return filter.value
      ? taskListDb.search(filter.value).map(({ item }) => item)
      : taskItems.value;
  });

  const groupedTasks = computed(
    () =>
      data.value?.types
        ?.filter(category => category.enabled && category.key !== "tools")
        .map(category => ({
          label: category.label,
          key: category.key,
          icon: getTaskIcon(category.key, category.icon),
          items: taskListSearchResults.value?.filter(t => {
            const [namespace, platform] = t.namespace.split("/");
            return namespace === "social-media"
              ? platform === category.key
              : namespace === category.namespace;
          }),
        }))
        ?.filter(c => c.items?.length) || []
  );

  return {
    tasks: groupedTasks,
    fallbackIcon: taskFallbackIcon,
    isLoading,
    filter,
  };
}
